<template>
  <div class="processPage">
    <ul class="ulBox clearFloat">
      <li class="blockLi">
        <div class="right">
          <el-table
            :data="grnList" stripe border style="width: 100%" size="mini">
            <el-table-column type="index" align="center"/>
            <el-table-column label="组件行号" width="80px" prop="posnr" align="center">
              <template slot-scope="scope">                
                <span>
                  {{scope.row.posnr ? scope.row.posnr : '-'}}                  
                </span>
              </template>
            </el-table-column>
            <el-table-column label="组件编码" width="180px" prop="matnr" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.matnr ? scope.row.matnr : '-'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="组件描述" show-overflow-tooltip prop="matnr" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.maktx ? scope.row.maktx : '-'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="需求数量" width="80px" prop="bdmng" align="center">
              <template slot-scope="scope">                
                <span>
                  {{scope.row.bdmng}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="投料LPN" width="180px" prop="grn" align="center">
              <template slot-scope="scope">                
                <span v-if="scope.row.grn">
                  {{scope.row.grn}}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="数量" width="80px" prop="enmng" align="center">
              <template slot-scope="scope">                
                <span v-if="scope.row.enmng">
                  {{scope.row.enmng}}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="载治具" prop="enmng" align="center">
              <template slot-scope="scope">                
                <span v-if="scope.row.fixture">
                  {{scope.row.fixture}}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="备料单号" width="180px" prop="orderNum2" align="center">
              <template slot-scope="scope">                
                <span v-if="scope.row.orderNum2">
                  {{scope.row.orderNum2}}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
    </ul>
  
  </div>
</template>
<script>
import {apiSapOrderItemsGrnSearch,apiSapOrderItemsGrnFeed} from "@/api/SapOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  computed: {
   
  },
  components: {
  },
  data() {
    return {
      grnList:[],
      numPages:0,
      src: '',
    };
  },
  methods: {
    async onSearch(callback) {
      const res = await apiSapOrderItemsGrnSearch({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.grnList = res.data;
        if (callback) callback();
      }
    },
    
    onFeedGrn() {
      let grn = null;
      const h = this.$createElement;
      this.$prompt(
        h("div", null, [
          h(
            "span",
            null,
            `请扫描或输入物料LPN，以记录工单所使用的物料`
          ),
        ]),
        "LPN投料",
        {
          confirmButtonText: `确认`,
          cancelButtonText: "取消",
          closeOnClickModal: false,
          inputValue: grn,
          beforeClose: (action, instance, done) => {
            grn=instance.inputValue;
            done();
          }
        }).then(async () => {
        const res = await apiSapOrderItemsGrnFeed({          
            id: this.tabPaneValue,
            grn: grn
        });
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.onSearch();
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.disabled_line {
  text-decoration: line-through;
}
</style>
